import { render, staticRenderFns } from "./TransportTypes.vue?vue&type=template&id=10bd7c4a&"
import script from "./TransportTypes.vue?vue&type=script&lang=js&"
export * from "./TransportTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports